import type { LocationQuery } from 'vue-router'

const SIGNED_IN_PARAM = 'signed-up'

export function checkSignUp(routeQuery: LocationQuery) {
  const { $cookie } = useNuxtApp()
  if (routeQuery[SIGNED_IN_PARAM] === 'true') {
    setSignedIn()
    return true
  }
  return $cookie.value.getSigned()
}

export function setSignedIn(shortDuration = false) {
  const { $cookie } = useNuxtApp()
  const expiryDate = new Date()
  if (shortDuration) {
    expiryDate.setHours(expiryDate.getHours() + 1)
  } else {
    expiryDate.setMonth(expiryDate.getMonth() + 1)
  }
  $cookie.value.setSigned(true, expiryDate)
}
